import { SocialButtons } from '../ProfileHeader/SocialButtons'
import { MembershipExtendedColors } from '../../common/membershipStyles'
import { PersonAvatar } from './PersonAvatar'

interface AccountManagerProps {
  accountManager: Record<string, any>
  colors: MembershipExtendedColors
}

export const AccountManager = ({
  accountManager,
  colors,
}: AccountManagerProps) => {
  return (
    <div className='flex box-border w-full max-w-[210px] max-h-[189px] lg:max-w-[280px] lg:max-h-[276px] p-5 flex-col items-center rounded-lg bg-white shadow-[0px_1px_10px_0px_rgba(0,0,0,0.10)]'>
      <SocialButtons
        email_address={accountManager?.email}
        linkedin_profile_url={accountManager?.linkedin_profile_url}
        showPhone={false}
        socialClassName='flex justify-end items-center gap-2 self-stretch w-full'
      />
      <div>
        <div className='flex lg:h-[220.459px] flex-col items-center gap-4 lg:gap-5 flex-shrink-0 self-stretch'>
          <PersonAvatar
            name={accountManager?.name}
            avatarUrl={accountManager?.avatar}
            avatarBg={colors.avatarBg}
            avatarStrokeColor={colors.avatarStrokeColor}
          />
          <p className='text-sm lg:text-base text-[#122D5C] text-center font-medium leading-normal lg:leading-6 tracking-wide'>
            Account Manager
          </p>
          <p className='text-xs lg:text-sm h-12 lg:h-15 text-[#405985] text-center font-normal leading-4 lg:leading-5 tracking-wide overflow-hidden'>
            {accountManager?.bio || 'No bio provided'}
          </p>
        </div>
      </div>
    </div>
  )
}
